import React, { Component, lazy, Suspense } from 'react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../../Layout/Auth";
import PaymentDetailsPage from '../Pages/PaymentDetailsPage';
import PaymentSuccess from '../Pages/PaymentSuccess';
import DecisionPage from '../Pages/DecisionPage';
import OnlinePaymentStatus from '../Pages/OnlinePaymentStatus';

function PaymentRoute() {
    const history = useHistory();
    return (
        <Switch>
            <Route
                exact
                path="/:lng/payment/:paymentDetailsHash?"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <PaymentDetailsPage history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/payment-success/:userDetailsData?/:paymentDetailsData?/:paidAmount?"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <PaymentSuccess history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/decision/:hss?/:pss?/:sss?"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <DecisionPage history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/online-payment-status"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <OnlinePaymentStatus history={history} />
                        </Suspense>
                    </Auth>
                )}
            />

        </Switch>
    );
}


export default PaymentRoute;
